import {  Duration } from "luxon";
export class MasterPlanLocation{
    id!: string;
    locationId!: string;
    name!: string;
    latitude!: number;
    longitude!: number;
    address!: string;
    postalCode!: string;
    city!: string;
    country!: string;
    locationType!: number;
    planContainerId!: string;
    segment!:string;
    stopTime!:Duration;
    productsAdditionalInfo? : ProductsForPlan[]
    checked?: boolean = false;
}

export class ProductsForPlan {
    productId?: string;
    productName?: string;
    productAdditionalInfo?: string;
    daoLocationKey?: string;
    productKeyMapping?: boolean;
}